module.exports = __webpack_public_path__ + "static/media/arrow-blue.2263d4a3.svg";